import React from 'react'
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import Moment from 'react-moment';

export default function ClockFunction() {
    const [myTime, setMyTime] = useState(new Date());
    const globalProps = useSelector(getGlobalProps)
    useEffect(() => {
        var timerID = setInterval(() => tick(), 1000);
        return () => {
            //Clear Interval when component unmount
            clearInterval(timerID)
        };
    }, []);


    function tick() {
        setMyTime(new Date());
    }

    return (
        <>
            <Clock myTime={myTime} timezone={globalProps.timezone} />
        </>
    );
}


function Clock(props) {
    return <span id="mirs-clock">
        {props.timezone}:

        <Moment tz={props.timezone} format="HH:mm:ss">
            {props.myTime}
        </Moment>
    </span>;
}






